import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Link } from "@reach/router";
import { SubscriptionContext } from "./subscriptionContext";
import { checkIfFinalized, getNextPayment, getStatus } from "./util";
import { Skeleton } from "@mantine/core";
import {
  IconAlertTriangle,
  IconCheck,
  IconCircleX,
  IconSnowflake,
} from "@tabler/icons-react";

const getIcon = (state, classes) => {
  switch (state) {
    case "Charged":
      return <IconCheck size={24} className={classes.icon} />;
    case "Charged failed":
    case "Registered":
      return <IconAlertTriangle size={24} className={classes.icon} />;
    case "Aborted":
    case "Cancelled":
      return <IconCircleX size={24} className={classes.icon} />;
    case "Frozen":
      return <IconSnowflake size={24} className={classes.icon} />;
    default:
      return "";
  }
};

const useStyles = makeStyles((theme) => ({
  link: { textDecoration: "none" },
  card: {
    color: theme.app.labelColor,
    padding: "16px 0",
    height: "100%",
    backgroundColor: theme.app.background[1],
    border: `1px solid ${theme.app.borderColor}`,
    borderRadius: "8px",
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.short,
      easing: theme.transitions.easing.easeInOut,
    }),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  cardHeader: {
    padding: "1rem 0 0.35rem 0",
    textAlign: "center",
    fontSize: "1.25rem",
    fontWeight: 500,
    display: "flex",
    justifyContent: "center",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  },
  icon: {
    width: "50px",
    height: "50px",
    "@media(max-width: 667px)": {
      width: "40px",
      height: "40px",
    },
  },
  nextPaymentContainer: {
    padding: "20px",
    fontSize: "1rem",
    textAlign: "center",
  },
  nextPaymentText: {
    height: "32px",
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const SubscriptionCard = () => {
  const classes = useStyles();
  const { data, subscriptionId, loading } = useContext(SubscriptionContext);

  if (loading)
    return (
      <Skeleton height={240}>
        <div className={classes.card}></div>
      </Skeleton>
    );

  const { subscriptionTypeName, charges, state, subscriptionTermType } =
    data.subscriptionDetails;
  const status = getStatus(state);
  const nextPayment = charges.length > 0 && getNextPayment(charges);
  const paidCharges = charges.filter((charge) => charge.status === "Charged");

  const subscriptionIsFinalized = checkIfFinalized(
    subscriptionTermType,
    paidCharges,
    charges,
    nextPayment
  );

  return (
    <Link
      to={`${process.env.PUBLIC_URL}/subscription/${subscriptionId}`}
      className={classes.link}
    >
      <div className={classes.card}>
        <span className={classes.cardHeader}>{subscriptionTypeName}</span>
        <div className={classes.iconContainer}>{getIcon(state, classes)}</div>
        <div className={classes.nextPaymentContainer}>
          <div className={classes.nextPaymentText}>
            {status !== "Aktiv" ? (
              <p>{status}</p>
            ) : nextPayment ? (
              <p>Nästa dragning: {nextPayment}</p>
            ) : subscriptionIsFinalized ? (
              <p>Slutfört</p>
            ) : (
              <p>{""}</p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SubscriptionCard;
